import { TextCodes } from '@api/types/translation/TextCodes';
import {
  CustomTextField,
  Textarea,
  Title,
  WarrantyClaimTypeFields,
  useWarrantyClaimContext,
} from '@components';
import { useAuth } from '@hooks';
import { Grid } from '@mui/material';
import { t } from '@translations';

export const WarrantyDescriptionSection = () => {
  const { form, isReadOnly } = useWarrantyClaimContext();
  const selectedBrand = form.watch('brand');
  const isHondaSelected = selectedBrand === 'Honda';
  const isOtherSelected = selectedBrand === 'Others';
  const { isBeremaUser } = useAuth();

  return (
    <>
      <Title noDot variant='h3'>
        {t(TextCodes.Warranty.Block.IssueDescription)}
      </Title>
      {isOtherSelected ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Textarea
              multiline
              rows={5}
              sx={{
                mt: 5,
              }}
              {...form.register('issueDescription', { required: true })}
              error={!!form.formState.errors.issueDescription}
              label={t(TextCodes.Warranty.Block.IssueDescription)}
              variant='outlined'
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
            <WarrantyClaimTypeFields />
          </Grid>

          {isBeremaUser && (
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    sx={{ mt: 5 }}
                    {...form.register('symptomCode')}
                    label={t(TextCodes.Warranty.Block.SymptomCode)}
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    sx={{ mt: 5 }}
                    {...form.register('defectCode')}
                    label={t(TextCodes.Warranty.Block.DefectCode)}
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      ) : (
        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Textarea
              multiline
              rows={5}
              {...form.register('issueDescription', { required: true })}
              error={!!form.formState.errors.issueDescription}
              label={t(TextCodes.Warranty.Block.IssueDescription)}
              variant='outlined'
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
            {isHondaSelected && (
              <CustomTextField
                sx={{ mt: 5 }}
                {...form.register('partCouseError', { required: true })}
                error={!!form.formState.errors.partCouseError}
                label={t(TextCodes.Warranty.Block.PartNoError)}
                InputProps={{
                  readOnly: isReadOnly,
                }}
              />
            )}
            {isBeremaUser && (
              <Grid container spacing={{ xs: 0, md: 2 }}>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    sx={{ mt: 5 }}
                    {...form.register('symptomCode')}
                    label={t(TextCodes.Warranty.Block.SymptomCode)}
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    sx={{ mt: 5 }}
                    {...form.register('defectCode')}
                    label={t(TextCodes.Warranty.Block.DefectCode)}
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                  />
                </Grid>
              </Grid>
            )}
            <WarrantyClaimTypeFields />
          </Grid>
          <Grid item xs={12} md={6}>
            <Textarea
              multiline
              rows={5}
              sx={{
                mt: { xs: 3, md: 0 },
              }}
              {...form.register('possibleErrorCauses', { required: true })}
              error={!!form.formState.errors.possibleErrorCauses}
              label={t(TextCodes.Warranty.Block.PossibleCauseOfError)}
              variant='outlined'
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
            <Textarea
              multiline
              rows={5}
              sx={{
                mt: 5,
              }}
              {...form.register('moreInformation', { required: true })}
              error={!!form.formState.errors.moreInformation}
              label={t(TextCodes.Warranty.Block.MoreInformation)}
              variant='outlined'
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};
